import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { ChecklistProfileSurvey } from '../../class/checklist-profile-survey';

@Injectable()
export class ChecklistProfileSurveyService extends WebService {

    public getChecklistProfileSurvey (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('list_doc_profile_survey'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/checklist-profile-surveis?${params}`, options);
    }

    public newChecklistProfileSurvey(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/checklist-profile-surveis`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateChecklistProfileSurvey(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/checklist-profile-surveis/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteChecklistProfileSurvey(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/checklist-profile-surveis/${id}`, { headers: this.headers } );
    }

    public infoChecklistProfileSurvey(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/checklist-profile-surveis?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/checklist-profile-survey/checklist-profile-survey.service.ts